import React from 'react';

import SignedImage from '../../../containers/System/SignedImage';
import {getLocalizedStrings} from '../../../services/localization/localizationService';

const LeviaLearnMoreItem = ({item}) => {
    const localizedStrings = getLocalizedStrings();
    const {icon: SvgIcon, iconPath, titleKey} = item;

    if (!localizedStrings[titleKey]) return null;

    return (
        <li className='flex items-center gap-1 text-start md:gap-2'>
            <div className='h-12 w-12 shrink-0'>
                {iconPath ? (
                    <SignedImage imgClassName='w-full h-full object-contain' mediaData={iconPath} signIfNull />
                ) : (
                    SvgIcon && <SvgIcon className='h-full w-full' />
                )}
            </div>
            <div>{localizedStrings[titleKey]}</div>
        </li>
    );
};

export default LeviaLearnMoreItem;
